import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const FEES_REQUEST = 'FETCH_FEES_REQUEST';
export const FEES_FAILURE = 'FETCH_FEES_FAILURE';
export const FEES_SUCCESS = 'FETCH_FEES_SUCCESS';

export const fetchFees = () => {
    return function(dispatch) {
        dispatch(fetchRequest());
        return axios(apiRequestOptions(apiPath.FEES.LIST))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRequest = () => {
    return {
        type: FEES_REQUEST,
    }
};

const fetchFailure = (error) => {
    return {
        type: FEES_FAILURE,
        error,
    }
};

const fetchSuccess = (data) => {
    return {
        type: FEES_SUCCESS,
        data,
    }
};